// Google Analytics 动态注入。从 /exports/config 获取 GA ID，有则加载 gtag。
// GA ID 由后端 config.yaml analytics.google_id 控制（空=不加载）。

let loaded = false

export async function initAnalytics(): Promise<void> {
  if (loaded) return
  try {
    const resp = await fetch('/api/v1/exports/config')
    if (!resp.ok) return
    const cfg = await resp.json()
    const gaID: string | undefined = cfg.google_analytics_id
    if (!gaID) return
    injectGtag(gaID)
    loaded = true
  } catch {
    /* 静默：GA 加载失败不影响功能 */
  }
}

function injectGtag(id: string): void {
  const w = window as any
  w.dataLayer = w.dataLayer || []
  w.gtag = function (...args: any[]) {
    w.dataLayer.push(args)
  }
  w.gtag('js', new Date())
  w.gtag('config', id)

  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(s)
}
